var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6907 14.4577C9.74257 14.587 9.86935 14.6704 10.0086 14.6668C10.1478 14.6632 10.2702 14.5735 10.3154 14.4417L14.6487 1.77504C14.6923 1.65445 14.6622 1.51955 14.5715 1.42889C14.4809 1.33823 14.346 1.30815 14.2254 1.35171L1.5587 5.68504C1.42694 5.73022 1.33717 5.85257 1.33361 5.99181C1.33004 6.13106 1.41343 6.25784 1.5427 6.30971L6.82937 8.42971C7.16708 8.56492 7.43488 8.83224 7.5707 9.16971L9.6907 14.4577",
    stroke: "#006AC0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5692 1.42969L7.27588 8.72235",
    stroke: "#006AC0",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSendIcon);
export default __webpack_public_path__ + "static/media/email-send-icon.1ab372e4894be41f9cfd47e963e51bd4.svg";
export { ForwardRef as ReactComponent };